<template>
  <v-container
    fluid
    v-if="key"
  >
    <base-material-card
      inline
      icon="mdi-view-list-outline"
      :title="title"
    >
      <v-card-actions>
        <v-btn
          v-if="canAdd"
          color="primary"
          @click="showAddForm"
        >Add</v-btn>
      </v-card-actions>
      <data-table
        :fetch-from="fetchFrom"
        :fields="fields"
        ref="table"
      >
        <template
          slot="actions"
          slot-scope="slotData"
        >
          <v-btn
            v-if="canEdit"
            small
            color="primary"
            @click="showEditForm(slotData.rowData.id)"
          >Edit</v-btn>
          <v-btn
            v-if="!canEdit"
            small
            color="primary"
            @click="showEditForm(slotData.rowData.id)"
          >View</v-btn>
        </template>

      </data-table>
      <modal-form
        :show="showForm"
        v-on:update:show="showForm=$event"
        :title="formTitle"
        v-on:saveData="saveData"
        :readonly="!canEdit"
      >
        <code-list-form
          :read-only="!canEdit"
          :field-key="key"
          v-model="item"
          :id="id"
        ></code-list-form>
      </modal-form>
    </base-material-card>
  </v-container>

</template>

<script>
  import consts from '@/components/codelist/defines/consts'
  import DataTable from '@/components/DataTable'
  import CodeListsService from '@/services/code-list'
  import ModalForm from '@/components/ModalForm'
  import CodeListForm from '@/views/code-list/CodeListForm'
  import PermissionsMixin from '@/mixins/Permissions'

  export default {
    name: 'View',
    components: { CodeListForm, ModalForm, DataTable },
    mixins: [
      PermissionsMixin,
    ],
    data () {
      return {
        showForm: false,
        key: undefined,
        item: {},
      }
    },
    watch: {
      $route: 'fetchData',
    },
    computed: {
      title () {
        return consts.codeLists[this.key].title
      },
      addTitle () {
        return 'Add ' + this.title
      },
      editTitle () {
        return 'Edit ' + this.title
      },
      formTitle () {
        if (this.item.id) {
          return this.editTitle
        }
        return this.addTitle
      },
      id () {
        return this.item.id
      },
      fields () {
        // todo: maybe add this to consts for codelist?
        return [
          {
            name: 'name',
            title: 'Name',
          },
          {
            name: '__slot:actions',
            title: 'Actions',
          },
        ]
      },
      permissions () {
        return consts.codeLists[this.key].permissions
      },
      canAdd () {
        const permissions = this.permissions
        if (!permissions) {
          return true
        }
        for (const rp of permissions.add) {
          const res = this.checkPermission(rp)
          if (!res) {
            return false
          }
        }
        return true
      },
      canEdit () {
        const permissions = this.permissions
        if (!permissions) {
          return true
        }
        for (const rp of permissions.edit) {
          const res = this.checkPermission(rp)
          if (!res) {
            return false
          }
        }
        return true
      },
    },
    mounted () {
      this.fetchData()
    },
    methods: {
      fetchFrom (urls, options) {
        const ns = new CodeListsService(this.key)
        return ns.getForList(options.params)
      },
      fetchData () {
        this.key = this.$route.params.key
        this.$refs.table.refresh()
      },
      showAddForm () {
        this.item = {}
        this.showForm = true
      },
      showEditForm (id) {
        const ns = new CodeListsService(this.key)
        ns.get(id).then((response) => {
          this.item = response.data.data
          this.showForm = true
        })
      },
      checkPermission (key) {
        if (key === 'edit_project') {
          return this.editProjects()
        } else if (key === 'edit_contact') {
          return this.editContacts()
        }
        return false
      },
      saveData () {
        if (this.item.id) {
          // save edited value
          const ns = new CodeListsService(this.key)
          ns.put(this.item.id, this.item).then((response) => {
            this.showForm = false
            this.$store.commit('codeList/clearKeyCache', this.key)
            this.$refs.table.refresh()
          })
        } else {
          // add new value
          const ns = new CodeListsService(this.key)
          ns.add(this.item).then((response) => {
            this.showForm = false
            this.$store.commit('codeList/clearKeyCache', this.key)
            this.$refs.table.refresh()
          })
        }
      },
    },
  }
</script>

<style scoped>

</style>
